import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import { InfoOutlined } from '@material-ui/icons'
import { IconButton, TextField } from '@material-ui/core'
import { Field } from 'react-formality'

import connectPropTypes from './utilities/connectPropTypes'
import handlerToCallUpdateIfValid from './utilities/Data/handlerToCallUpdateIfValid'
import getField from './utilities/Data/getField'
import Form from './components/Form'
import getFieldValueInUnit from './utilities/Data/User/getFieldValueInUnit'
import Img from './components/Img'
import DistanceUnitField from './components/Edit/DistanceUnitField'
import MassUnitField from './components/Edit/MassUnitField'
import DateOfBirthPicker from './components/DateOfBirthPicker'

import editStyles from './Edit.icss'

class EditStatistics extends React.Component {
	constructor(props) {
		super(props)

		this.handlerToCallStatisticsUpdateIfValid = handlerToCallUpdateIfValid(props.userProfileStatisticsUpdate, { history: props.history })
		this.form = React.createRef()
		this.inputRef = React.createRef()
		this.scrollTimeout = null
		this.handleEditHeight = this.handleEditHeight.bind(this)
		this.handleEditWeight = this.handleEditWeight.bind(this)

		props.appShowBottomBar(false)
		props.appShowBottomNavBar(true)
		props.appBottomNavBarHandleClick(() => this.form.current.submit())
	}

	componentDidMount() {
		this.props.appHeading({ text: this.context.translate('Your measurements') })
		this.props.appBottomNavBarLabelNext(this.context.translate('Done'))
	}

	handleEditHeight() {
		this.props.appRedirect('/editheight')
	}

	handleEditWeight() {
		this.props.appRedirect('/editweight')
	}

	render() {
		if (!this.props.user.userProfile) {
			return null
		}

		const statistics = getField(this.props.user, 'userProfile.statistics')

		return (
			<section>
				<div className={editStyles.pagePadding}>
					<Form
						ref={this.form}
						onSubmit={({ values, isValid }) => isValid && this.props.userProfileStatisticsUpdate({ values, goBack: true, history: this.props.history })}
						className={classNames(editStyles.oneColumn)}
						initialValues={{
							height: getFieldValueInUnit(statistics, 'height') || '',
							heightUnit: getField(statistics, 'height.unit') || 'cm',
							weight: getFieldValueInUnit(statistics, 'weight') || '',
							weightUnit: getField(statistics, 'weight.unit') || 'kg',
							dateOfBirth: getFieldValueInUnit(statistics, 'dateOfBirth') || null
						}}
					>
						{(props) => {
							const handlerToCallStatisticsUpdateIfValid = this.handlerToCallStatisticsUpdateIfValid(props.store)
							return (
								<React.Fragment>
									<h2>{this.context.translate('Your measurements!')}</h2>
									<p className={editStyles.imgSurround}>
										<Img content="/images/content/guide/height.svg" className={editStyles.img} />
									</p>
									<div className={editStyles.statistic}>
										<Field
											component={TextField}
											name="height"
											className={editStyles.statisticValue}
											placeholder={props.values.heightUnit}
											label={this.context.translate('Height')}
											value={props.values.height}
											type="number"
											onBlur={handlerToCallStatisticsUpdateIfValid('height', 'heightUnit')}
											validate={{
												numericality: true
											}}
										/>
										<DistanceUnitField
											name="heightUnit"
											value={props.values.heightUnit}
											onBlur={handlerToCallStatisticsUpdateIfValid('heightUnit', 'height')}
											onChange={props.store.setBinder('heightUnit')}
										/>
										<IconButton
											aria-label="Height Info"
											classes={{
												label: editStyles.alignedIcon
											}}
											onClick={this.handleEditHeight}
										>
											<InfoOutlined />
										</IconButton>
									</div>
									<div className={editStyles.statistic}>
										<Field
											component={TextField}
											name="weight"
											className={editStyles.statisticValue}
											placeholder={props.values.weightUnit}
											label={this.context.translate('Weight')}
											value={props.values.weight}
											type="number"
											onBlur={handlerToCallStatisticsUpdateIfValid('weight', 'weightUnit')}
											validate={{
												numericality: true
											}}
										/>
										<MassUnitField
											name="weightUnit"
											value={props.values.weightUnit}
											onBlur={handlerToCallStatisticsUpdateIfValid('weightUnit', 'weight')}
											onChange={props.store.setBinder('weightUnit')}
										/>
										<IconButton
											aria-label="Weight Info"
											classes={{
												label: editStyles.alignedIcon
											}}
											onClick={this.handleEditWeight}
										>
											<InfoOutlined />
										</IconButton>
									</div>
									<Field
										// Field
										className={editStyles.statisticValueFullwidth}
										component={DateOfBirthPicker}
										getComponentValue={date => date.format('YYYY-MM-DD')}
										name="dateOfBirth"
										value={props.values.dateOfBirth}
										// unfortunately, can't set type="number" - setSelectionRange (needed masking) is not supported
										onBlur={handlerToCallStatisticsUpdateIfValid('dateOfBirth')}
										// DatePicker
										// TODO: this might well go into the DateOfBirthPicker when it properly manages it's _single_ value
										onInputChange={(e) => {
											if (!e.target.value) {
												props.store.set('dateOfBirth', null)
											}
										}}
										// Validation
										validate={{
											datetime: {
												dateOnly: true,
												earliest: moment().subtract(123, 'years'),
												latest: moment(),
												tooEarly: this.context.translate('is too far in the past'),
												tooLate: this.context.translate('is in the future')
											}
											// need to validate that the picker value is accepted (conforms to the mask...) and valid
											// maybe by making this a component that has only one (string) value, rather than a datetime value and a string value when editing...
										}}
									/>
								</React.Fragment>
							)
						}}
					</Form>
				</div>
			</section>
		)
	}
}

EditStatistics.contextTypes = {
	translate: PropTypes.func
}

EditStatistics.propTypes = {
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	appHeading: PropTypes.func.isRequired,
	appRedirect: PropTypes.func.isRequired,
	userProfileStatisticsUpdate: PropTypes.func.isRequired,
	user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired
}

export default connectPropTypes(EditStatistics)



// WEBPACK FOOTER //
// ./src/EditStatistics.jsx